import { css } from 'styled-components';
import { media } from '../../theme';

const setMaxWidth = ({
  fluid
}) => css(["", ";"], () => !fluid && [media.xs`max-width: 34em`, media.sm`max-width: 45em`, media.md`max-width: 60em`, media.lg`max-width: 71.5em`]);

export default setMaxWidth;